import PropTypes from "prop-types"
import { useEffect, useRef } from "react"

import { isTestMode } from "helpers/application"

/*global affirm*/

const Affirm = ({ price }) => {
  const affirmPriceRef = useRef()

  useEffect(() => {
    if (!isTestMode) {
      dataLayer.push({
        event: "load-affirm",
      })
    }
  }, [])

  return (
    <a
      className="text-link text-12 block cursor-pointer [&>span]:border-b"
      style={{ minHeight: "18px" }}
    >
      <span
        className="affirm-as-low-as"
        // data-affirm-color={logoColor}
        data-amount={price}
        data-learnmore-show="false"
        data-page-type="product"
        ref={() => {
          if (
            typeof affirm !== "undefined" &&
            affirm.ui &&
            affirm.ui.refresh &&
            affirmPriceRef.current != price
          ) {
            affirm.ui.refresh()
            affirmPriceRef.current = price
          }
        }}
      />
    </a>
  )
}

Affirm.propTypes = {
  price: PropTypes.number,
}

export default Affirm
